/**
 * GET `admin/jobs/runs` — журнал запусков фоновых задач (новые сверху),
 * пагинация смещением. Старые записи бэк чистит сам.
 */

import {apiEnabled, http} from '@services/utils';

import {MOCK_RUNS} from '../mocks';
import {asNum, asObj, toJobRun} from '../toSystem';
import type {JobRunsPage} from '../types';

export type GetJobRunsRequest = {job: string | null; limit: number; offset: number};

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const getJobRuns = async (req: GetJobRunsRequest): Promise<JobRunsPage> => {
  if (!apiEnabled) {
    await sleep(200);
    const all = MOCK_RUNS.filter((r) => req.job === null || r.jobName === req.job);
    return {items: all.slice(req.offset, req.offset + req.limit), total: all.length};
  }
  const r = asObj(
    await http('admin/jobs/runs', {
      params: {job: req.job, limit: req.limit, offset: req.offset},
      skipCaseConversion: true,
    }),
  );
  return {
    items: (Array.isArray(r.items) ? r.items : []).map(toJobRun),
    total: asNum(r.total),
  };
};
